module.exports = __webpack_public_path__ + "img/stifta.6e8e7d42.svg";